import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  locationReducer,
} from '../../utils/redux';

export const consts = createReqConsts('auth', 'create-password');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users/reset_password',
  slug: [
    {
      type: 'payload',
      selector: ['token'],
    },
  ],
  type: 'put',
});

export const reducer = createReqReducer(consts);
export default locationReducer(reducer);



// WEBPACK FOOTER //
// ./src/redux/auth/create-password.js